<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="text-center login_title login_titleBox">
          《{{ $store.state.Name }}》{{ this.title }}
        </div>
        <div class="login_maxBox">
          <div class="container login_box">
            <el-tabs v-model="activeName">
              <el-tab-pane label="找回密码" name="first" class="ten">
                <el-form
                  ref="form"
                  :model="form"
                  label-width="80px"
                  class="twenfive"
                >
                  <el-form-item label="重置密码:">
                    <el-col>
                      <el-input
                        placeholder="请输入新密码"
                        maxlength="16"
                        type="password"
                        @blur="DetectInput($event, 'pwd')"
                        @input="DetectKey($event, 'pwd')"
                        v-model="pwd"
                        autocomplete="off"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                    <!-- <div class="msg_right" v-if="pwdTiShi == ''">
                      根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）
                    </div> -->
                  </el-form-item>
                  <el-form-item label="确认密码:">
                    <el-col>
                      <el-input
                        maxlength="16"
                        class="ipt_phone"
                        flag="password"
                        name="repassword"
                        type="password"
                        value
                        placeholder="请再次输入新密码"
                        @blur="DetectInput($event, 'rpwd')"
                        @input="DetectKey($event, 'rpwd')"
                        v-model="rpwd"
                        autocomplete="off"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>
                  <el-form-item label>
                    <el-button style="width: 48%" type="primary" @click="forgot"
                      >提交</el-button
                    >
                    <el-button
                      style="width: 48%"
                      class="ml1"
                      @click="$router.push('/')"
                      >取消</el-button
                    >
                  </el-form-item>
                  <div class="clearfix"></div>
                  <div
                    class="leftfloat highgreen"
                    style="margin-left: 3px"
                    v-if="Ispush"
                  >
                    <i class="el-icon-success"></i> 提交成功！
                  </div>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                没有账号?<a
                  href="javascript:void(0)"
                  @click="$router.push('/regist')"
                  >立即注册</a
                >
              </p>
              <p class="text-center">
                使用其他方式登录&nbsp;&nbsp;<a href="/">返回首页</a>
              </p>
              <p class="text-center" v-if="isweixin || IsQQLogin">
                已经有<span v-if="IsQQLogin">QQ，</span>
                <span v-if="isweixin">微信</span
                >账号，可直接登录，不用重复注册。
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <!-- <div class="weixin" onclick="this.className = 'weixin on';"> -->
                <el-button
                  v-if="isweixin"
                  type="text"
                  @click="wxshow()"
                  class="weixin"
                  ><img src="../../assets/images/add_wx1.png"
                /></el-button>
                <!-- <a href="javascript:;"><img   @mouseenter="wxshow()" src="../../assets/images/add_wx1.png"></a> -->
                <el-dialog
                  :visible.sync="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">长按识别二维码注册并登录</p>
                    <p class="pclist eqcode">请用微信扫描二维码注册并登录</p>

                    <div>
                      <img :src="src" width="150" height="150" style="" />
                    </div>
                  </div>
                </el-dialog>

                <a
                  style="cursor: pointer"
                  @click="useqqlogin"
                  class="qq_login"
                  v-if="IsQQLogin"
                  ><img src="../../assets/images/add_qq1.png"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <el-dialog
      :visible.sync="pwdFalseShow"
      width="27%"
      class="errDia"
      :before-close="handleClose"
      title="提示"
    >
      <div style="text-align: center">
        <p>
          您的密码不符合相关要求，请<router-link
            to="/ChangePassword"
            style="color: red"
            >点击此处</router-link
          >修改密码。
        </p>
      </div>
    </el-dialog>
    <MasterButtom></MasterButtom>
  </div>
</template>

<script>
var timeStop;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
import Login_WeiXin from "../../components/Login/Login_WeiXin";
import MasterButtom from "../../components/MasterButtom";
export default {
  name: "login",
  data() {
    return {
      showWx: false,
      isweixin: false,
      dialogVisible: false,
      src: "",
      loading: true,
      form: {
        name: "",
        type: "",
        pass: "",
        user: "",
        yzcode: "",
        yzcodes: "",
      },
      Ispush: false,
      activeName: "first",
      texta: "",
      textb: "",
      Btn1: "",
      iscodeBtna: true,
      status: 1,
      phoneAndEmail: "",
      code: "",
      Code: "",
      pwd: "",
      rpwd: "",
      phoneAndEmailTiShi: "            ",
      codeTiShi1: "            ",
      pwdTiShi: "            ",
      rpwdTiShi: "            ",
      wait: 60,
      codeTiShi: -1,
      backgroundDiv: {
        backgroundImage:
          "url(" + require("../../assets/images/login_bg.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      },
      user_type: "",
      title: "找回密码",
      Btn: "发送验证码",
      Picture: "",
      Picturebase: "",
      codeImg: require("../../assets/images/timg.jpg"),
      GUIDS: "",
      codeTiShis: "",
      codeshow: true,
      pwdFalseShow: false,
      Registered: [],
      checkAll: false,
      checkedName: [],
      isIndeterminate: true,
      Registereds: "",
    };
  },
  components: {
    Login_WeiXin,
    MasterButtom,
  },
  async created() {
    this.initVeri();
  },
  async mounted() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == "是") {
            this.texta = "手机/";
            this.textb = "手机号或";
          } else {
            this.texta = "";
            this.textb = "";
          }
        }
        if (item.SetItemID == 2960) {
          if (item.Item_Value == "是") {
            this.isweixin = true;
          } else {
            this.isweixin = false;
          }
        }
      });
    }
    this.Btn1 = "发送" + this.texta + "邮箱验证码";
  },
  watch: {
    checkedName(newa, olda) {
      let set = new Set(newa);
      let num = Array.from(set);
      this.Registereds = num;
    },
  },
  methods: {
    handleCheckAllChange(val) {
      if (this.checkAll) {
        this.Registered.forEach((item) => {
          this.checkedName.push(item.RegisterId);
        });
      } else {
        this.checkedName = [];
      }
    },
    handleCheckedCitiesChange(value) {
      if (this.checkedName.length == this.Registered.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    async wxshow() {
      this.dialogVisible = true;
      let carousel = await this.$store.dispatch("_getGetQrcode");
      if (carousel) {
        this.src = carousel.data.Url;
        this.Code = carousel.data.Code;
        this.loading = false;
        this.handleQrcodeCheck(this.type);
        this.$emit("func", this.src);
      }
    },
    handleQrcodeCheck(type) {
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch("_getWeiXinLogin", { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
              if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true;
                return;
              }
              this.$message({ message: "登录成功", type: "success" });
              localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
              var urldomain = "/";
              window.location.href = urldomain;
              this.$emit("fuab", false);
            }
          });
      }, 2000);
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
    //鼠标离开
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == "pwd") {
        if (this.$Bai(elem.target.value)) {
          return (this.pwdTiShi = "密码不能为空");
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi = "密码不能小于八位字符");
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = "密码不能含有空格");
        } else if (this.$base(elem.target.value, "aff")) {
          return (this.pwdTiShi = "密码中含有非法字符");
        } else if (!this.$base(elem.target.value, "pass")) {
          return (this.pwdTiShi =
            "根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）");
        } else {
          this.pwdTiShi = "";
        }
      } else if (type == "rpwd") {
        if (this.$Bai(elem.target.value)) {
          this.rpwdTiShi = "确认密码不能为空";
        } else if (elem.target.value.length < 8) {
          this.rpwdTiShi = "确认密码不得少于八位字符";
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = "密码不能含有空格");
        } else {
          this.rpwdTiShi = "";
        }
      }
    },
    //正在输入时清空错误提示
    DetectKey(elem, type) {
      let base = this.base;
      if (type == "phoneAndEmail") {
        return (this.phoneAndEmailTiShi = "");
      } else if (type == "code") {
        return (this.codeTiShi1 = "");
      } else if (type == "pwd") {
        return (this.pwdTiShi = "");
      } else if (type == "rpwd") {
        return (this.rpwdTiShi = "");
      }
    },

    async initVeri() {
      let resbase = await this.$store.dispatch("_getVerificationcodeImg");
      if (resbase.data.IsSuccess) {
        this.GUID = resbase.data.Data.GUID;
        this.Picturebase = resbase.data.Data.Picture;
      } else {
        console.log(resbase.data.Message);
      }
    },
    randomColor() {
      var col = "rgb(";
      for (var i = 0; i < 3; i++) {
        col += Math.floor(Math.random() * 256) + ",";
      }
      col = col.slice(0, -1);
      col += ")";
      return col;
    },
    forgot(e) {
      //忘记密码  提交
      let status = 0;
      if (this.status == 0) {
        return;
      }
      if (this.$Bai(this.pwd)) {
        status = 1;
        this.pwdTiShi = "密码不能为空";
      } else if (this.pwd.length < 8) {
        status = 1;
        this.pwdTiShi = "密码不能小于8位字符";
      } else if (this.$Space(this.pwd)) {
        status = 1;
        this.pwdTiShi = "密码不能含有空格";
      } else if (this.$base(this.pwd, "aff")) {
        status = 1;
        this.pwdTiShi = "密码中含有非法字符";
      } else if (!this.$base(this.pwd, "pass")) {
        status = 1;
        this.pwdTiShi =
          "根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）";
      }
      if (this.$Bai(this.rpwd)) {
        status = 1;
        this.rpwdTiShi = "确认密码不能为空";
      } else if (this.rpwd.length < 8) {
        status = 1;
        this.rpwdTiShi = "确认密码不能小于8位字符";
      } else if (this.$Space(this.rpwd)) {
        status = 1;
        this.rpwdTiShi = "确认密码不能含有空格";
      } else if (this.$base(this.rpwd, "aff")) {
        status = 1;
        this.rpwdTiShi = "确认密码中含有非法字符";
      } else if (this.pwd != this.rpwd) {
        status = 1;
        this.rpwdTiShi = "两次密码输入不一致";
      }
      if (status == 1) {
        return;
      }
      let pwm = md5(this.pwd + "!@*Samson*@!");
      let pwaes = CryptoJS.AES.encrypt(this.pwd, pwm).toString();
      var data = {
        Guid: this.$route.query.Guid,
        NewPassword: pwaes,
        Npwm: pwm,
      };
      this.$store.dispatch("_ForgetPasswordByGuid", data).then((res) => {
        if (res.data.IsSuccess) {
          sessionStorage.setItem("text", 1);
          alert("找回密码成功~~~");
          this.$router.push("/Login");
        } else {
          return alert(res.data.Message);
        }
      });
    },
    useqqlogin() {
      var urldz =
        "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=" +
        window.OpenId +
        "&response_type=token&scope=all&redirect_uri=" +
        window.callBackHtp +
        "%2F%23%2Flogin_qq";
      window.location.href = urldz;
    },
  },
};
</script>

<style scoped>
.el-button--primary.is-plain {
  color: #fff;
}
.rolesC {
  margin-right: 50px;
  margin-bottom: 5px;
}
.el-checkbox__label {
  display: inline-block !important;
}
</style>
